/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse } from 'axios';
import { processRequestError } from '../error/actions';
import { GET_BALANCE_REQUEST, CREATE_BALANCE_REQUEST } from './types';
import { getBalanceAction, createBalanceAction } from './actions';
import { BalanceApi } from '../../services/Balance';

// Сага для получения баланса
function* handleGetBalanceSaga(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(BalanceApi.getBalance);
    yield put(getBalanceAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: getBalanceAction.failure }));
  }
}

// Сага для создания баланса
function* handleCreateBalanceSaga(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(BalanceApi.createBalance);
    yield put(createBalanceAction.success(response.data));
  } catch (error: any) {
    yield put(processRequestError({ error, failAction: createBalanceAction.failure }));
  }
}

// // Сага для создания операции
// function* handleCreateOperationSaga(
//   action: ReturnType<typeof createOperationAction.request>,
// ): SagaIterator {
//   try {
//     const response: AxiosResponse = yield call(BalanceApi.createOperation, action.payload);
//     yield put(createOperationAction.success(response.data));
//   } catch (error: any) {
//     yield put(processRequestError({ error, failAction: createOperationAction.failure }));
//   }
// }

// Главная сага для баланс модуля
export function* balanceSaga(): SagaIterator {
  yield takeLatest(GET_BALANCE_REQUEST, handleGetBalanceSaga);
  yield takeLatest(CREATE_BALANCE_REQUEST, handleCreateBalanceSaga);
  // yield takeLatest(CREATE_OPERATION_REQUEST, handleCreateOperationSaga);
}
